import type { RecordRef } from "@/profitability/records/objects";
import { sameRecord } from "@/profitability/records/objects";
import { findingRef } from "./finding-row";
import { useFindings } from "./query";
import type { Finding } from "./types";

/** A linked finding stays reachable outside the queue's page or status filter. */
export const useSelectedFinding = (
  businessId: string,
  reportId: string,
  runId: string | null,
  selected: RecordRef | null,
  items: Finding[],
) => {
  const queued = selected
    ? items.find((item) => sameRecord(findingRef(item), selected))
    : undefined;
  const query = useFindings(
    businessId,
    reportId,
    "all",
    {
      dataset: selected?.dataset,
      recordIds: selected ? [selected.recordId] : undefined,
      runId: runId ?? undefined,
    },
    { enabled: !!selected && !queued },
  );
  return {
    finding: selected
      ? (queued ?? query.data?.pages[0]?.findings[0])
      : undefined,
    query,
  };
};
